import globalVars from '@aon/aon-tws-common-ui/build/lib/globalVars.module.scss';
import React from 'react';
import styled from 'styled-components';
import ContentConstants from '../../contentConstants';
import { SurveyStep } from '../../models';
import { StepNote } from './SurveyStepItem';

export interface ISurveySubStepItemProps {
	id: string;
	step: SurveyStep;
	isActive: boolean;
	disabled: boolean;
	hasNote: boolean;
	onClick: () => void;
}

const SubStepText = styled.div<{ isActive: boolean; disabled: boolean }>`
	font-size: 12px;
	font-weight: 500;
	line-height: 1.5em;
	color: ${(props) => (props.isActive ? globalVars.mainBlue : globalVars.gray3)};
	padding-left: 20%;
	margin-bottom: 5px;

	${(props) =>
		props.disabled || props.isActive
			? 'pointer-events: none;'
			: `cursor: pointer;
		:hover {
			color: ${globalVars.mainBlue};
		}`}
`;
SubStepText.displayName = 'SubStepText';

const SurveySubStepItem = ({ id, step, isActive, disabled, hasNote, onClick }: ISurveySubStepItemProps) => {
	const getDisplayText = () => {
		switch (step) {
			case SurveyStep.Define:
				return ContentConstants.STEPPER_STEP_DEFINE_BASICS;
			case SurveyStep.DefineQuestions:
				return ContentConstants.STEPPER_STEP_DEFINE_QUESTIONS;
			case SurveyStep.ManageDimensions:
				return ContentConstants.STEPPER_STEP_MANAGE_DIMENSIONS;
			case SurveyStep.BrandingAndTheme:
				return ContentConstants.STEPPER_STEP_BRANDING_AND_THEME;
			case SurveyStep.LogicAndLayout:
				return ContentConstants.STEPPER_STEP_LOGIC_AND_LAYOUT;
		}
	};

	return (
		<SubStepText id={id} isActive={isActive} disabled={disabled} onClick={() => (isActive || disabled ? null : onClick())}>
			{getDisplayText()}
			{hasNote ? <StepNote name='note' /> : null}
		</SubStepText>
	);
};

export default SurveySubStepItem;
